<template>
    <div class="x_box">
        <div class="x_header item-page-header">
            <div class="item-title">
                <h4>{{ $t('item_list') }}</h4>
                <span>{{ $t('total_record') }}: {{ query.Total }}</span>
            </div>
            <div class="item-actions">
                <button type="button" class="btn btn-outline-primary btn-sm no-bor" @click="$router.go(-1)"><i class="fa fa-arrow-circle-o-left"></i> {{ $t('back') }}</button>
                <template v-if="permission==1">
                    <router-link to="/item/create" class="btn btn-primary btn-sm no-bor">
                        <i class="fa fa-plus-circle"></i> {{$t('new')}}
                    </router-link>
                    <button type="button" class="btn btn-outline-primary btn-sm no-bor" @click="print">
                        <i class="fa fa-print" aria-hidden="true"></i>
                        {{$t('print')}}
                    </button>
                    <button type="button" class="btn btn-outline-primary btn-sm no-bor" @click="exportExcel">
                        <i class="fa fa-file-excel-o" aria-hidden="true"></i>
                        {{$t('export_excel')}}
                    </button>
                </template>
            </div>
        </div>
        <div class="x_body item-page">
            <div class="card x_card filter-card">
                <div class="card-body">
                    <div class="item-filter-grid">
                        <div class="form-group">
                            <label class="label-control blue">{{ $t('search') }}</label>
                            <div class="input-icon">
                                <i class="fa fa-search" aria-hidden="true"></i>
                                <input type="text" class="form-control form-control-sm" :placeholder="$t('item_code') + ' / ' + $t('item_name')" v-model.trim="query.Text" @keypress.enter="searchItems"/>
                            </div>
                        </div>
                        <div class="form-group">
                            <label class="label-control blue">{{ $t('item_category_list') }}</label>
                            <select class="form-control form-control-sm" v-model="query.CategoryId">
                                <option value="">{{$t('all')}}</option>
                                <option v-for="ret in categories" :value="ret.Id" :key="ret.Id">{{ret.Name}}</option>
                            </select>
                        </div>
                        <div class="form-group" v-if="permission==1">
                            <label class="label-control blue">{{ $t('vendor') }}</label>
                            <VendorDropdown :key="filterVersion" @select="vendorSelected"></VendorDropdown>
                        </div>
                        <div class="filter-buttons">
                            <button type="button" class="btn btn-primary btn-sm" @click="searchItems"><i class="fa fa-search" aria-hidden="true"></i> {{$t('search')}}</button>
                            <button type="button" class="btn btn-outline-secondary btn-sm" :disabled="!isFiltered" @click="resetFilters"><i class="fa fa-refresh" aria-hidden="true"></i> {{$t('reset')}}</button>
                        </div>
                    </div>
                </div>
            </div>

            <template v-if="permission==1">
                <div class="summary-grid">
                    <div class="summary-card">
                        <span>{{ $t('begin_stock') }}</span>
                        <strong>{{ $number(summary.BeginStock, '0,0.[00]') }}</strong>
                    </div>
                    <div class="summary-card">
                        <span>{{ $t('ending_stock') }}</span>
                        <strong>{{ $number(summary.EndStock, '0,0.[00]') }}</strong>
                    </div>
                    <div class="summary-card">
                        <span>{{ $t('total_cost') }}</span>
                        <strong>{{ $dollar(summary.Cost) }}</strong>
                    </div>
                    <div class="summary-card">
                        <span>{{ $t('total_price') }}</span>
                        <strong>{{ $dollar(summary.Price) }}</strong>
                    </div>
                </div>
            </template>

            <div class="card x_card item-list-card">
                <div class="card-header item-list-toolbar">
                    <div>
                        <strong>{{ $t('item_list') }}</strong>
                        <span>{{ currentStart }} - {{ currentEnd }} / {{ query.Total }}</span>
                    </div>
                    <div class="btn-group tool-group" role="group">
                        <button type="button" class="btn btn-default btn-sm" @click="viewTypeChange(1)" :class="{active:viewType==1}"><i class="fa fa-th-large" aria-hidden="true"></i></button>
                        <button type="button" class="btn btn-default btn-sm" @click="viewTypeChange(0)" :class="{active:viewType==0}"><i class="fa fa-list-ul" aria-hidden="true"></i></button>
                    </div>
                </div>
                <div class="card-body">
                    <div class="table-responsive item-table-wrap" v-if="viewType==0">
                    <table class="table table-hover table-sm no-bor v-top item-table">
                        <thead>
                            <tr>
                                <th class="text-center" style="width: 50px;">{{ $t('no') }}</th>
                                <th class="sorting">
                                    <button type="button" class="sort-field" @click="onSort('Num')">{{ $t('item_code') }} <i :class="sortIcon('Num')" aria-hidden="true"></i></button>
                                </th>
                                <th class="sorting">
                                    <button type="button" class="sort-field" @click="onSort('Name')">{{ $t('item_name') }} <i :class="sortIcon('Name')" aria-hidden="true"></i></button>
                                </th>
                                <th class="sorting" v-if="permission==1">
                                    <button type="button" class="sort-field" @click="onSort('VendorName')">{{ $t('vendor')}} <i :class="sortIcon('VendorName')" aria-hidden="true"></i></button>
                                </th>
                                <th class="sorting">
                                    <button type="button" class="sort-field" @click="onSort('CategoryName')">{{ $t('category') }} <i :class="sortIcon('CategoryName')" aria-hidden="true"></i></button>
                                </th>
                                <th class="sorting">
                                    <button type="button" class="sort-field" @click="onSort('UomName')">{{ $t('uom') }} <i :class="sortIcon('UomName')" aria-hidden="true"></i></button>
                                </th>
                                <th class="sorting" v-if="permission==1">
                                    <button type="button" class="sort-field" @click="onSort('Cost')">{{ $t('cost') }} <i :class="sortIcon('Cost')" aria-hidden="true"></i></button>
                                </th>
                                <th class="sorting">
                                    <button type="button" class="sort-field" @click="onSort('Price')">{{ $t('price_sale') }} <i :class="sortIcon('Price')" aria-hidden="true"></i></button>
                                </th>
                                <th class="sorting" v-if="permission==1">
                                    <button type="button" class="sort-field" @click="onSort('BeginQty')">{{ $t('begin_stock') }} <i :class="sortIcon('BeginQty')" aria-hidden="true"></i></button>
                                </th>
                                <th class="sorting" v-if="permission==1">
                                    <button type="button" class="sort-field" @click="onSort('EndingQty')">{{ $t('ending_stock') }} <i :class="sortIcon('EndingQty')" aria-hidden="true"></i></button>
                                </th>
                                <th class="sorting" v-if="permission==1">
                                    <button type="button" class="sort-field" @click="onSort('TotalCost')">{{ $t('total_cost') }} <i :class="sortIcon('TotalCost')" aria-hidden="true"></i></button>
                                </th>
                                <th class="sorting" v-if="permission==1">
                                    <button type="button" class="sort-field" @click="onSort('TotalPrice')">{{ $t('total_price') }} <i :class="sortIcon('TotalPrice')" aria-hidden="true"></i></button>
                                </th>
                            </tr>
                        </thead>
                        <tbody>
                            <template v-for="(ret, index) in records">
                                <tr :key="ret.Id || index">
                                    <td class="text-center">{{ rowNumber(index) }}</td>
                                    <td>{{ ret.Num }}</td>
                                    <td>
                                        <router-link v-if="permission==1" :to="{ name: 'item_edit', params:{ id:ret.Id }}">{{ret.Name}}</router-link>
                                        <span v-else>{{ret.Name}}</span>
                                    </td>
                                    <td v-if="permission==1">{{ret.VendorName}}</td>
                                    <td>{{ret.CategoryName}}</td>
                                    <td class="text-center">{{ret.UomName}}</td>
                                    <td v-if="permission==1" class="text-right"><router-link :to="{name: 'cost_item_history', params: {id:ret.Id}}">{{$dollar(ret.Cost)}}</router-link></td>
                                    <td class="text-right">{{$dollar(ret.Price)}}</td>
                                    <td v-if="permission==1" class="text-right">{{$number(ret.BeginQty, '0,0.[00]')}}</td>
                                    <td v-if="permission==1" class="text-right" :class="genColor(ret)">
                                        <router-link :to="{name: 'report_stock_summary', params: {id:ret.Id}}" target="_blank">{{$number(ret.EndingQty, '0,0.[00]')}}</router-link>
                                    </td>
                                    <td v-if="permission==1" class="text-right">{{$dollar(ret.TotalCost)}}</td>
                                    <td v-if="permission==1" class="text-right">{{$dollar(ret.TotalPrice)}}</td>
                                </tr>
                            </template>
                            <tr v-if="records.length==0">
                                <td :colspan="permission==1?12:6" class="empty-row">{{ $t('total_record') }}: 0</td>
                            </tr>
                        </tbody>
                        <tfoot>
                            <tr>
                                <th :colspan="permission==1?8:6" class="text-right">{{$t('total')}} :</th>
                                <th v-if="permission==1" class="text-right">{{$number(summary.BeginStock, '0,0.[00]')}}</th>
                                <th v-if="permission==1" class="text-right">{{$number(summary.EndStock, '0,0.[00]')}}</th>
                                <th v-if="permission==1" class="text-right">{{$dollar(summary.Cost)}}</th>
                                <th v-if="permission==1" class="text-right">{{$dollar(summary.Price)}}</th>
                            </tr>
                        </tfoot>
                    </table>
                    </div>
                    <div class="item-card-grid" v-else>
                        <div class="item-card" v-for="(ret, index) in records" :key="ret.Id || index">
                            <div class="item-card-image">
                                <img :src="itemImage(ret)" :alt="ret.Name" @error="useDefaultImage">
                            </div>
                            <div class="item-card-top">
                                <span class="item-index">{{ rowNumber(index) }}</span>
                                <span class="item-code">{{ ret.Num || 'NA' }}</span>
                            </div>
                            <router-link v-if="permission==1" class="item-card-name" :to="{ name: 'item_edit', params:{ id:ret.Id }}">{{ret.Name}}</router-link>
                            <strong v-else class="item-card-name">{{ret.Name}}</strong>
                            <div class="item-card-meta">
                                <span>{{ ret.CategoryName || '-' }}</span>
                                <span>{{ ret.UomName || '-' }}</span>
                            </div>
                            <div class="item-card-meta" v-if="permission==1">
                                <span>{{ $t('vendor') }}</span>
                                <strong>{{ ret.VendorName || '-' }}</strong>
                            </div>
                            <div class="item-card-stats">
                                <div v-if="permission==1">
                                    <span>{{ $t('cost') }}</span>
                                    <router-link :to="{name: 'cost_item_history', params: {id:ret.Id}}">{{$dollar(ret.Cost)}}</router-link>
                                </div>
                                <div>
                                    <span>{{ $t('price_sale') }}</span>
                                    <strong>{{$dollar(ret.Price)}}</strong>
                                </div>
                                <div v-if="permission==1">
                                    <span>{{ $t('ending_stock') }}</span>
                                    <router-link :class="['stock-pill', itemStockClass(ret)]" :to="{name: 'report_stock_summary', params: {id:ret.Id}}" target="_blank">{{$number(ret.EndingQty, '0,0.[00]')}}</router-link>
                                </div>
                            </div>
                        </div>
                        <div v-if="records.length==0" class="empty-row grid-empty">{{ $t('total_record') }}: 0</div>
                    </div>
                </div>
                <div class="card-footer">
                    <div class="pagination-info">
                        <strong>{{ currentStart }} - {{ currentEnd }}</strong>
                        <span>/ {{ query.Total }}</span>
                    </div>
                    <div class="pagination-controls">
                        <div class="page-size">
                            <span>បង្ហាញ</span>
                            <select class="form-control form-control-sm" v-model.number="query.Limit" @change="pageSizeChange">
                                <option v-for="size in pageSizes" :key="size" :value="size">{{ size }}</option>
                            </select>
                        </div>
                        <b-pagination
                            size="sm"
                            pills
                            :total-rows="query.Total"
                            :per-page="query.Limit"
                            :limit="5"
                            v-model="query.Page"
                            :prev-text="$t('pre')"
                            :next-text="$t('next')"
                            hide-goto-end-buttons
                            @change="paging($event)"/>
                    </div>
                </div>
            </div>
        </div>
    </div>
</template>
<script>
    import { VendorDropdown } from '../Vendors';
    export default {
        components: { VendorDropdown },
        data: function(){
            return {
                query:{
                    Page: 1,
                    Total: 0,
                    Limit: 25,
                    Text: '',
                    ProductTypeId: '',
                    CategoryId: '',
                    VendorId: '',
                    SortType: '',
                    SortField: ''
                },
                records:[],
                categories: [],
                pageSizes: [25, 50, 100],
                viewType: 0,
                filterVersion: 0,
                summary: {
                    BeginStock: 0,
                    EndStock: 0,
                    Cost: 0,
                    Price: 0,
                }
            }
        },
        created: function(){
            if(this.routerNum == 100){
                this.query.Text = this.filter.Text;
            }else{
                this.$store.state.routenum = 100;
            }
            this.$api().post('category').then(res => {
                if (this.$isValid(res)) {
                    this.categories = res.data.Data;
                }
            });
            this.toList();
        },
        methods: {
            toList: function(){
                var loading = this.$loading.show();
                this.query.Page = this.query.Page || 1;
                this.$api().post('item/list', this.query).then(res => {
                    if(this.$isValid(res)){
                        this.records = res.data.Data;
                        this.summary = res.data.Json.Summary;
                        this.query.Total = res.data.Total;
                    }
                }).finally(function(){ loading.hide();});
            },
            searchItems(){
                this.query.Page = 1;
                this.toList();
            },
            print: function(){
                window.open('/print/price/list?t=0', '_blank');
            },
            paging(e){
                this.query.Page = e;
                this.toList();
            },
            pageSizeChange(){
                this.query.Page = 1;
                this.toList();
            },
            viewTypeChange(n){
                this.viewType = n;
                this.$store.state.filter.coa.IsGroup = n==0?false:true;
            },
            resetFilters(){
                this.query.Text = '';
                this.query.ProductTypeId = '';
                this.query.CategoryId = '';
                this.query.VendorId = '';
                this.query.SortType = '';
                this.query.SortField = '';
                this.query.Page = 1;
                this.filterVersion += 1;
                this.toList();
            },
            genColor(item){
                var ret = '';
                if(item.AlertQty > 0){
                    if(item.EndingQty <= 0) ret = 'bg-danger';
                    else if(item.EndingQty <= item.AlertQty) return 'bg-warning';
                }
                return ret;
            },
            itemStockClass(item){
                if(item.AlertQty > 0){
                    if(item.EndingQty <= 0) return 'stock-danger';
                    if(item.EndingQty <= item.AlertQty) return 'stock-warning';
                }
                return 'stock-normal';
            },
            vendorSelected(item){
                this.query.VendorId = item ? item.Id : '';
                this.query.Page = 1;
            },
            rowNumber(index){
                return ((this.query.Page - 1) * this.query.Limit) + index + 1;
            },
            sortIcon(field){
                if(this.query.SortField != field) return 'fa fa-sort text-muted';
                return this.query.SortType == 'ASC' ? 'fa fa-sort-asc' : 'fa fa-sort-desc';
            },
            itemImage(item){
                if(item.Image) return this.$base() + 'image/items/' + item.Image;
                return '/img/no-image.svg';
            },
            useDefaultImage(event){
                event.target.src = '/img/no-image.svg';
            },
            exportExcel(){
                var loading = this.$loading.show();
                this.$api()({
                    url: this.$base() + 'item/export/excel',
                    method: 'post',
                    data: this.query,
                    responseType: 'blob'
                }).then(res => {
                    const url = window.URL.createObjectURL(new Blob([res.data]));
                    const link = document.createElement('a');
                    link.href = url;
                    link.setAttribute('download', 'items.xlsx');
                    document.body.appendChild(link);
                    link.click();
                }).finally(function(){ loading.hide();});
            },
            onSort(field){
                if(this.query.SortField != field){
                    this.query.SortField = field;
                    this.query.SortType = 'ASC';
                    this.query.Page = 1;
                    this.toList();
                    return;
                }
                this.query.SortField = field;
                if(this.query.SortType == 'ASC') this.query.SortType = 'DESC';
                else this.query.SortType = 'ASC';
                this.query.Page = 1;
                this.toList();
            }
        },
        computed: {
            routerNum: function(){
                return this.$store.state.routenum;
            },
            filter: function(){
                return this.$store.state.filter;
            },
            permission(){
                return this.$store.state.userGroup;
            },
            currentStart(){
                if(this.query.Total == 0) return 0;
                return ((this.query.Page - 1) * this.query.Limit) + 1;
            },
            currentEnd(){
                var end = this.query.Page * this.query.Limit;
                return end > this.query.Total ? this.query.Total : end;
            },
            isFiltered(){
                return this.query.Text != ''
                    || this.query.ProductTypeId != ''
                    || this.query.CategoryId != ''
                    || this.query.VendorId != ''
                    || this.query.SortField != '';
            }
        },
        destroyed(){
            this.$store.state.filter.Text = this.query.Text;
        }
    }
</script>
<style scoped>
    .item-page-header{
        align-items: center;
        display: flex;
        justify-content: space-between;
        gap: 12px;
        flex-wrap: wrap;
        padding: 10px 12px;
    }
    .item-title h4{
        color: #0856ab;
        font-size: 17px;
        font-weight: 700;
        line-height: 1.25;
        margin: 0;
    }
    .item-title span{
        color: #6b7280;
        display: block;
        font-size: 12px;
        margin-top: 3px;
    }
    .item-actions{
        align-items: center;
        display: flex;
        flex-wrap: wrap;
        gap: 6px;
        justify-content: flex-end;
    }
    .item-page{
        display: grid;
        gap: 12px;
    }
    .filter-card,
    .item-list-card{
        border: 1px solid #dfe7f1;
        border-radius: 6px;
        box-shadow: 0 1px 2px rgba(15, 23, 42, 0.04);
    }
    .item-filter-grid{
        align-items: flex-end;
        display: grid;
        gap: 10px;
        grid-template-columns: minmax(220px, 1.4fr) minmax(180px, 1fr) minmax(180px, 1fr) auto;
    }
    .item-filter-grid .form-group{
        margin-bottom: 0;
    }
    .input-icon{
        position: relative;
    }
    .input-icon .fa{
        color: #94a3b8;
        left: 9px;
        position: absolute;
        top: 8px;
    }
    .input-icon .form-control{
        padding-left: 28px;
    }
    .filter-buttons{
        display: flex;
        gap: 6px;
        justify-content: flex-end;
        white-space: nowrap;
    }
    .summary-grid{
        display: grid;
        gap: 10px;
        grid-template-columns: repeat(4, minmax(0, 1fr));
    }
    .summary-card{
        background: #f8fbff;
        border: 1px solid #dce9f8;
        border-radius: 6px;
        padding: 10px 12px;
    }
    .summary-card span{
        color: #64748b;
        display: block;
        font-size: 12px;
        margin-bottom: 4px;
    }
    .summary-card strong{
        color: #0856ab;
        display: block;
        font-size: 16px;
        line-height: 1.25;
    }
    .item-list-toolbar{
        align-items: center;
        background: #fff;
        border-bottom: 1px solid #e5edf6;
        display: flex;
        justify-content: space-between;
        gap: 10px;
        padding: 10px 12px;
    }
    .item-list-toolbar strong{
        color: #1f2937;
        display: block;
        font-size: 14px;
    }
    .item-list-toolbar span{
        color: #6b7280;
        font-size: 12px;
    }
    .item-table-wrap{
        border: 1px solid #e5edf6;
        border-radius: 6px;
    }
    .item-table{
        margin-bottom: 0;
        min-width: 980px;
    }
    .table.v-top tr>td{
        vertical-align: middle;
    }
    .item-table thead th{
        background: #f8fbff;
        border-bottom: 1px solid #dbe6f3;
        color: #334155;
        font-weight: 700;
        position: sticky;
        top: 0;
        z-index: 1;
    }
    .item-table tbody td{
        border-top: 1px solid #edf2f7;
    }
    .item-table tfoot th{
        background: #f8fafc;
        border-top: 1px solid #dbe6f3;
        color: #0856ab;
    }
    .sort-field{
        background: transparent;
        border: 0;
        color: inherit;
        cursor: pointer;
        font-size: inherit;
        font-weight: inherit;
        padding: 0;
        text-align: left;
        white-space: nowrap;
    }
    .sort-field .fa{
        color: #0856ab;
        margin-left: 4px;
    }
    .empty-row{
        color: #64748b;
        padding: 24px !important;
        text-align: center;
    }
    .item-card-grid{
        display: grid;
        gap: 10px;
        grid-template-columns: repeat(auto-fill, minmax(260px, 1fr));
    }
    .item-card{
        border: 1px solid #e1e9f4;
        border-radius: 6px;
        display: flex;
        flex-direction: column;
        gap: 9px;
        min-height: 260px;
        padding: 12px;
    }
    .item-card-image{
        align-items: center;
        background: #f8fbff;
        border: 1px solid #e5edf6;
        border-radius: 6px;
        display: flex;
        height: 112px;
        justify-content: center;
        overflow: hidden;
    }
    .item-card-image img{
        height: 100%;
        object-fit: contain;
        padding: 8px;
        width: 100%;
    }
    .item-card-top,
    .item-card-meta{
        align-items: center;
        display: flex;
        gap: 8px;
        justify-content: space-between;
    }
    .item-index{
        align-items: center;
        background: #eef6ff;
        border-radius: 5px;
        color: #0856ab;
        display: inline-flex;
        font-weight: 700;
        height: 26px;
        justify-content: center;
        min-width: 30px;
        padding: 0 8px;
    }
    .item-code{
        color: #64748b;
        font-size: 12px;
        overflow: hidden;
        text-overflow: ellipsis;
        white-space: nowrap;
    }
    .item-card-name{
        color: #009efb;
        display: -webkit-box;
        font-size: 14px;
        font-weight: 700;
        line-height: 1.45;
        min-height: 40px;
        overflow: hidden;
        text-decoration: none;
        -webkit-box-orient: vertical;
        -webkit-line-clamp: 2;
    }
    .item-card-meta{
        color: #64748b;
        font-size: 12px;
    }
    .item-card-meta strong{
        color: #334155;
        font-weight: 600;
        overflow: hidden;
        text-overflow: ellipsis;
        white-space: nowrap;
    }
    .item-card-stats{
        border-top: 1px solid #eef2f7;
        display: grid;
        gap: 8px;
        grid-template-columns: repeat(3, minmax(0, 1fr));
        margin-top: auto;
        padding-top: 10px;
    }
    .item-card-stats div{
        min-width: 0;
    }
    .item-card-stats span{
        color: #64748b;
        display: block;
        font-size: 11px;
        margin-bottom: 3px;
    }
    .item-card-stats strong,
    .item-card-stats a{
        color: #0856ab;
        font-size: 13px;
        font-weight: 700;
    }
    .stock-pill{
        border-radius: 5px;
        display: inline-block;
        min-width: 46px;
        padding: 2px 6px;
        text-align: center;
    }
    .stock-normal{
        background: #eef6ff;
    }
    .stock-warning{
        background: #fff3cd;
        color: #7a4f00 !important;
    }
    .stock-danger{
        background: #f86c6b;
        color: #fff !important;
    }
    .grid-empty{
        border: 1px solid #e1e9f4;
        border-radius: 6px;
        grid-column: 1 / -1;
    }
    .card-footer{
        align-items: center;
        background: #fff;
        border-top: 1px solid #e5edf6;
        display: flex;
        justify-content: space-between;
        gap: 12px;
        padding: 9px 12px;
    }
    .pagination-info{
        align-items: baseline;
        color: #64748b;
        display: flex;
        font-size: 12px;
        gap: 4px;
        white-space: nowrap;
    }
    .pagination-info strong{
        color: #0856ab;
        font-size: 13px;
    }
    .pagination-controls{
        align-items: center;
        display: flex;
        flex-wrap: wrap;
        gap: 10px;
        justify-content: flex-end;
    }
    .page-size{
        align-items: center;
        color: #64748b;
        display: flex;
        font-size: 12px;
        gap: 6px;
        white-space: nowrap;
    }
    .page-size .form-control{
        height: 29px;
        min-width: 68px;
        padding-bottom: 2px;
        padding-top: 2px;
    }
    .card-footer .pagination{
        margin-bottom: 0;
    }
    @media (max-width: 991.98px){
        .item-filter-grid{
            grid-template-columns: repeat(2, minmax(0, 1fr));
        }
        .summary-grid{
            grid-template-columns: repeat(2, minmax(0, 1fr));
        }
        .item-card-stats{
            grid-template-columns: repeat(2, minmax(0, 1fr));
        }
        .filter-buttons{
            justify-content: flex-start;
        }
    }
    @media (max-width: 575.98px){
        .item-page-header,
        .item-actions,
        .item-list-toolbar,
        .card-footer{
            align-items: stretch;
            flex-direction: column;
        }
        .pagination-controls{
            align-items: stretch;
            justify-content: flex-start;
        }
        .page-size{
            justify-content: space-between;
        }
        .card-footer .pagination{
            justify-content: center;
        }
        .item-actions .btn,
        .item-actions a,
        .filter-buttons .btn{
            width: 100%;
        }
        .item-filter-grid,
        .summary-grid{
            grid-template-columns: 1fr;
        }
        .item-card-grid,
        .item-card-stats{
            grid-template-columns: 1fr;
        }
        .filter-buttons{
            flex-direction: column;
        }
    }
</style>
